<template>
    <div>
        <colorPicker style="width: 120px" class="color_picker_btn"/>
    </div>
</template>

<script>
    import colorPicker from './colorPickerTest.vue';

    export default {
        components: {
            colorPicker
        }
    }
</script>

<style scoped>
    .color_picker_btn {
        border-right: 1px solid #D4D4D4;
    }
</style>